var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[(!_vm.readonly)?[(_vm.val.length > 0)?_vm._l((_vm.val),function(tel,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(tel)+" ")])}):[_vm._v("无")]]:[_vm._v(_vm._s(_vm.value || '无'))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }